<template>
  <div class="main-container">
    <DataReady id="content">
      <div class="content-block">
        <NoCompany v-if="!hasCompany"></NoCompany>
        <TasksTable :rootFilter="rootFilter"
                    :taskStatus="'active'"
        ></TasksTable>
      </div>
      <div v-if="showGantt"
           class="content-block"
      >
        <Gantt
          :projects="myProjects"
        ></Gantt>
      </div>
      <ProjectTable
        v-if="showProjects"
        :projectStatus="'$all'"
        :rootFilter="rootFilter"
      ></ProjectTable>
    </DataReady>
  </div>
</template>

<script>
import NoCompany from '../components/first-run/no-company'
import TasksTable from 'CORE/components/task/table'
import ProjectTable from 'CORE/components/project/table'
import DataReady from 'CORE/components/utilities/data-ready'
import EntityQuery from 'CORE/utils/entity-query'
import Gantt from 'CORE/components/gantt/gantt'
import labels from 'CORE/utils/labels'
import _ from 'lodash'

const isTaggedAs = (propertyType, tagName) => {
    return _.get(propertyType, `settings.systags.${tagName}`, false)
}

export default {
    name: 'Dashboard',
    components: {
        NoCompany,
        TasksTable,
        DataReady,
        Gantt,
        ProjectTable,
    },
    data() {
        return {
            tasksTableCollapsed: true,
        }
    },
    computed: {
        showGantt() {
            const settings = this.$store.getters.settings
            return _.get(settings, 'gui.pages.dashboard.showGantt', false)
        },
        showProjects() {
            const settings = this.$store.getters.settings
            return _.get(settings, 'gui.pages.dashboard.showProjects', false)
        },
        myProjects() {
            return _.filter(this.$store.getters.projects, p => {
                const matches = _.chain(p.propertyValues)
                    .pick(this.assigneeKeys)
                    .filter(pv => _.size(_.intersection(_.get(pv, 'value.value'), _.map(this.myResources, r => r.id))))
                    .value()
                return _.size(matches) > 0
            })
        },
        hasCompany() {
            return this.$store.getters.hasCompany
        },
        myResources() {
            const q = new EntityQuery(this.$store)
            return _.filter(this.$store.getters.resources, r => {
                const myValues = _.filter(q.pickPropertyValuesByTag(r, 'resourceUser'), (v, key) => {
                    const userId = _.head(_.get(v, 'value.value'))
                    return userId === this.$store.getters.currentUserId
                })
                return _.size(myValues) > 0
            })
        },
        assigneeKeys() {
            return _.map(_.filter(this.$store.getters.propertyTypes, pt => isTaggedAs(pt, 'assignee')), pt => pt.key)
        },
        rootFilter() {
            const filter = {}
            _.each(this.assigneeKeys, k => {
                filter[k] = _.join(_.map(this.myResources, r => labels.resource(r)), ' ')
            })

            return filter
        },
        filterAssignedToMe() {
            return o => {
                const person = _.get(o, `systagsValues.calendarPerson`)
                if (person === this.$store.getters.currentUserId) {
                    return o
                }
            }
        },
    },
}
</script>

<style>
.collapsed {
    max-height: 40vh;
    margin: 0;
    padding: 0;
    overflow: hidden;
}
.spaced {
  margin-left: 20px;
  margin-top: 8px;
}
</style>

